import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import { Doughnut } from "react-chartjs-2";
import { getAudienceAnalytics } from "api/AudienceApi";
import { getCompany } from "api/AccountsApi";
import Moment from "moment";
import ContactLoader from "views/ContantLoader";
import "../../assets/css/eventsReport.css"
import { ReactComponent as I1 } from './1.svg';
import { ReactComponent as I2 } from './2.svg';
import { ReactComponent as I3 } from './3.svg';

import './styles.css'
export default class AllAudience extends React.Component {
  state = {
    arr: [],
    fromdate: "",
    todate: "",
    dontLoad: false,
    content: [],
    audiences: [],
    labels: ["Bounces", "Email Delivered"],
    companyName: "",
    datasets: [
      {
        label: "Rainfall",
        backgroundColor: ["#3BA1FF", "#4ECB74"],
        hoverBackgroundColor: ["#3BA1FF", "#4ECB74"],
        data: [5, 5],
      },
    ],
  };

  options = {
    cutoutPercentage: 75,
    weight: 0.4,
    legend: {
      display: true,
      position: "bottom",
      fontSize: 14,
      labels: {
        usePointStyle: true,
        fontSize: 12,
      },
    },
    tooltips: {
      bodySpacing: 0,
      mode: "nearest",
      intersect: 0,
      position: "nearest",
      xPadding: 10,
      yPadding: 10,
      caretPadding: 30,
      cornerRadius: 15,
    },
  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({ dontLoad: true });
    }, 10000);
    getAudienceAnalytics()
      .then((data) => {
        const content = data;

        this.setState({ content });
        const fromdate = Moment(data.period.fromDate).format("MMM D,YYYY");
        this.setState({ fromdate });
        const todate = Moment(data.period.toDate).format("MMM D,YYYY");
        this.setState({ todate });
        this.state.datasets[0].data = [data.totalBounce, data.totalDelivery];
        let audiences = content.topAudiences;
        this.setState({ audiences });
      })
      .catch((e) => { });

    getCompany()
      .then((data) => {
        this.setState({ companyName: data.name });
      })
      .catch((e) => { });
  }

  render() {
    return (
      <>
      <div className="gjogr eBox" style={{marginTop:0}} >
        <div className="dwpfpwj">
          
          Audience Overview

        </div>
        <div className="row acclcdpdc">
          <div className="col-md-6">
            <Doughnut
                          data={this.state}
                          options={{
                            cutoutPercentage: 75,
                            weight: 0.2,
                            legend: {
                              display: true,
                              position: "bottom",
                              fontSize: 14,
                              labels: {
                                usePointStyle: true,
                                fontSize: 12,
                              },
                            },
                            tooltips: {
                              bodySpacing: 0,
                              mode: "nearest",
                              intersect: 0,
                              position: "nearest",
                              xPadding: 10,
                              yPadding: 10,
                              caretPadding: 30,
                              cornerRadius: 15,
                            },
                          }}
                        />
          </div>
          <div className="col-md-6 kolsls">
            <div className="aud-card">
              <I1 />
              <div className="swdwdr">
                <span>{this.state.content.totalOpen}</span>
                <h1>Email Open</h1>
              </div>

            </div>

            <div className="aud-card">
              <I2 />
              <div className="swdwdr">
                <span>{this.state.content.totalCampaign} {" Campaigns"}</span>
                <h1> From {this.state.fromdate} to {this.state.todate}</h1>
              </div>

            </div>

            <div className="aud-card">
              <I3 />
              <div className="swdwdr">
                <span> {this.state.content.numberOfAudience} {"New Audiences"}  </span>
                <h1> From {this.state.fromdate} to {this.state.todate}</h1>
              </div>

            </div>


          </div>
       

      </div>

      </div>


      <div className="gjogr eBox " style={{maxHeight:"500px", marginTop:0}} >
                    <div style={{ marginBottom: '20px' }}>
                        <div className="pgtop">
                            <span>Top Audiences</span>
                  

                        </div>
                        <table className="pageTable" style={{height:"none !important"}}>
                            {/* <colgroup>
                                <col span="1" style="width: 15%;">
                                    <col span="1" style="width: 70%;">
                            </colgroup> */}
                            <tbody>
                                <tr style={{ border: 'none' }}>
                                    <th style={{ width: '90%' }}>Audience</th>
                                    <th style={{ width: '20%' }}>Count</th>

                                </tr>
                                {
                                     this.state.audiences.length &&this.state.audiences.slice(0, 4).map((e, i) => {
                                        console.log("wsssssssssssss",e)
                                        return <tr>
                                            <td><h6 className="wrap" style={{ width: "400px" }}>{e.name}</h6></td>
                                            <td>

                                                <h1 className="num2" title="View"
                                                    style={{ fontSize: '12px' }}
                                                    // onClick={() => {
                                                    //     let obj = {
                                                    //         webpageUrl: e.webpageUrl,
                                                    //         noOfDays: noOfDays2,
                                                    //         count: e.count

                                                    //     }


                                                    //     props.props.history.push(`/admin/triggersAndEvents/PageViewsList`, obj)

                                                    // }
                                                    // }
                                                >{e.count}</h1>

                                            </td>

                                        </tr>
                                    })
                                }
                            </tbody>

                        </table>

                        <div className="jofe">

                        <a href="/admin/contact/audience/details" className="text_btn">
                        More audience{" "}
                        <span className="icon-arrow-down-sign-to-navigate"></span>
                        <span className="icon-arrow-down-sign-to-navigate"></span>
                      </a>
                        </div>
                
                    </div>


                </div>

   
  
      </>
    );
  }
}
